export class ConnectAzureSourceAccountRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tenantId",
            "baseName": "tenantId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "subscriptionId",
            "baseName": "subscriptionId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "managementGroupId",
            "baseName": "managementGroupId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceGroupName",
            "baseName": "resourceGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "eonInternalResourceGroupName",
            "baseName": "eonInternalResourceGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "managementAppRegistrationId",
            "baseName": "managementAppRegistrationId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "managementApplicationId",
            "baseName": "managementApplicationId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "dataAccessAppRegistrationId",
            "baseName": "dataAccessAppRegistrationId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "dataAccessApplicationId",
            "baseName": "dataAccessApplicationId",
            "type": "string",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return ConnectAzureSourceAccountRequest.attributeTypeMap;
    }
    constructor() {
    }
}
